export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '42.0.1',
    name: 'lingo2-web',
    versionDate: '2025-09-03T10:19:37.934Z',
    gitCommitHash: 'e4ca6c4',
    versionLong: '42.0.1-e4ca6c4',
};
export default versions;
